import { createContext, ReactNode } from "react";
interface DatepickerContext {
  focusedDate: Date | null;
  isDateBlocked: (date: Date) => boolean;
  isDateFocused: (date: Date) => boolean;
  isDateHovered: (date: Date) => boolean;
  isDateSelected: (date: Date) => boolean;
  isFirstOrLastSelectedDate: (date: Date) => boolean;
  onDateFocus: (date: Date) => void;
  onDateHover: (date: Date) => void;
  onDateSelect: (date: Date) => void;
  onDayRender?: (date: Date) => ReactNode;
  startDate: Date | null;
  endDate: Date | null;
}
const datepickerContextDefaultValue = {
  focusedDate: null,
  isDateFocused: () => false,
  isDateSelected: () => false,
  isDateHovered: () => false,
  isDateBlocked: () => false,
  isFirstOrLastSelectedDate: () => false,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {},
  startDate: null,
  endDate: null
};
export default createContext<DatepickerContext>(datepickerContextDefaultValue);